import { Component, inject } from '@angular/core';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from 'primeng/tabs';
import { KunderService } from '@features/kunder/kunder.service';
import { KundeResultComponent } from '@features/kunder/kunde-result/kunde-result.component';
import { KundeSearchComponent } from '@features/kunder/kunde-search/kunde-search.component';
import { KundeDetailComponent } from '@features/kunder/kunde-detail/kunde-detail.component';

@Component({
  selector: 'app-kunder',
  imports: [
    KundeDetailComponent,
    KundeResultComponent,
    KundeSearchComponent,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs
  ],
  templateUrl: './kunder.component.html',
  styleUrl: './kunder.component.css'
})
export class KunderComponent {
  kundeService = inject(KunderService);
  data = this.kundeService.datasource.data;

}
